import { WagmiProvider } from 'wagmi';

import { wagmiConfig } from './config';

interface WagmiProviderProps {
  children: React.ReactNode;
}

export const WagmiProviderCore: React.FC<WagmiProviderProps> = ({
  children,
}: WagmiProviderProps) => {
  return <WagmiProvider config={wagmiConfig}>{children}</WagmiProvider>;
};
